<template>
  <div class="room-qna-modal-component">
    <div class="room-qna-wrapper">
      <header class="room-qna-header">
        <h6>{{ $t("qna.title") }}</h6>
      </header>
      <div class="room-qna-content">
        <div class="qna-menu">
          <button class="qna-menu-btn menu-btn-list"
                  :class="{ selected : selectedTab === 'list'}"
                  @click="selectedTab = 'list'">{{ $t("qna.list.title") }}</button>
          <button class="qna-menu-btn menu-btn-form"
                  :class="[{ selected : selectedTab === 'form'}, { blocked : !isParticipantRole()}]"
                  @click="selectedTab = 'form'">{{ $t("qna.list.btn") }}</button>
        </div>
        <div class="qna-list-wrapper"
          v-if="selectedTab ==='list'">
          <div class="qna-order-select">
            <select class="form-select"
                    v-model="selectedOption"
            >
              <option v-for="(order, i) in orderOptions"
                      :value="order.value"
                      :key="i">{{order.label}}</option>
            </select>
          </div>
          <div class="qna-list">
            <div class="qna-list-empty"
              v-if="!questionList.length">
              {{ $t("qna.list.noQuestion") }}
            </div>
            <div class="qna-items-wrap"
              v-else>
              <ol class="qna-items">
                <li class="qna-item"
                    v-for="(question, i) in questionList"
                    :key="i">
                  <div class="qna-item-wrapper">
                    <div class="qna-q"></div>
                    <div class="qna-content">
                      <div class="qna-nickname">{{ question.nickname }}</div>
                      <div class="qna-text">{{ question.content }}</div>
                      <div class="qna-comment-btn-wrapper">
                          <button class="qna-like-btn" @click="onClickLike(question)">
                            <div class="qna-like-icon"
                                 :class="{ liked : !!question.likes.length}"></div>
                            <p>{{ $t("qna.like.title") }} {{ question.likes.length > 0 ? $t('qna.like.count', { '0' : question.likes.length }) : '' }}</p>
                          </button>
                          <button class="qna-comment-btn"
                                  @click="onClickComment(question.questionId)">{{ getCommentBtnText(question) }}</button>
                      </div>
                    </div>
                  </div>
                  <Transition name="slide-down">
                    <div class="qna-comment-list-wrapper"
                         v-if="qnaCommentId === question.questionId">
                      <ol class="qna-comment-list"
                          >
                        <li class="qna-comment-item"
                            v-for="(comment, i) in question.comments" :key="i">
                          {{comment}}
                          <div class="qna-comment-icon"></div>
                          <div class="qna-content">
                            <p class="qna-nickname" v-html="comment.username"></p>
                            <div class="qna-text">{{ comment.text }}</div>
                          </div>
                          <div class="qna-comment-regdate">{{ getRegDateForm(comment.regDate) }}</div>
                          <div class="btn-qna-comment-remove"
                               v-if="hasEmceeRole()"
                               v-tooltip="'댓글 삭제'"
                               @click="onClickDeleteComment(question.questionId, comment.commentId)"></div>
                        </li>
                      </ol>
                      <div class="qna-comment-input-wrapper">
                        <textarea class="qna-comment-input" :placeholder="$t('qna.placeholder')" maxlength="100"
                                  v-model="commentText" />
                        <button class="qna-comment-register-btn"
                                :class="{ active : !!commentText.length }"
                                @click="onClickPostComment(question.questionId)">{{ $t("qna.register.title") }}</button>
                      </div>
                    </div>
                  </Transition>
                  <div class="qna-regdate">{{ getRegDateForm(question.regDate) }}</div>
                  <div class="btn-qna-item-remove"
                       v-if="hasEmceeRole()"
                       @click="deleteQnA(question.questionId)"></div>

                </li>
              </ol>
            </div>
          </div>
        </div>
        <div class="qna-form"
          v-else>
          <div class="qna-form-wrapper">
            <div class="qna-form-header">
              <div class="qna-form-title">{{ $t("qna.question.text") }}</div>
              <div class="qna-form-len-layer">(<span class="qna-form-text-len">{{ questionText.length }}</span> / 100)</div>
            </div>
            <div class="qna-form-body">
              <textarea :value="questionText" :placeholder="$t('qna.placeholder')" maxlength="100"
                        @input="onInput($event)"
              ></textarea>
            </div>
            <div class="qna-form-footer"
                 :class="{active : !!questionText.length }"
                 @click="onClickRegister(questionText)">
              {{ $t("qna.question.register") }}
            </div>
          </div>
        </div>
      </div>
      <div class="qna-list-btn-wrap"
           v-if="hasEmceeRole()">
        <button class="btn-qna-list-save"
                @click="saveQuestions">
          {{ $t("qna.question.download") }}
        </button>
      </div>
      <div class="qna-close-wrap">
        <GrmCloseBtn @click="onClose" />
      </div>
      <label class="chk-my-qna"
             v-if="selectedTab ==='list' && !hasEmceeRole() && roomSetting['useQnAShare']">
        <input type="checkbox"
               v-model="showOnlyOwnQuestion"><span>{{ $t("qna.question.onlyMine") }}</span>
      </label>
    </div>
  </div>
</template>

<script>

import {mapActions, mapGetters, mapMutations} from "vuex";
import GrmCloseBtn from "@/components/Common/button/GrmCloseBtn"
import { saveAs } from 'file-saver';
import moment from "moment";
import * as _ from "lodash";

export default {
  name: 'RoomQnAModal',
  components:{
    GrmCloseBtn
  },
  computed: {
    ...mapGetters('user', [
      'me',
      'isMe',
      'getUsername',
      'hasEmceeRole',
      'isParticipantRole'
    ]),
    ...mapGetters('question', [
      'roomQuestionList',
      'myQuestionList'
    ]),
    ...mapGetters('roomSetting', ['roomSetting']),
    questionList(){
      if(this.showOnlyOwnQuestion || (!this.roomSetting['useQnAShare'] && this.isParticipantRole())){
        return this.sortedQuestionList(this.myQuestionList)
      } else {
        return this.sortedQuestionList(this.roomQuestionList)
      }
    }
  },
  data(){
    return {
      selectedTab: 'list',
      questionText: '',
      showOnlyOwnQuestion: false,
      commentText: '',
      qnaCommentId: '',
      orderOptions: [
        { value: 'recent', label: this.$t('qna.order.current') },
        { value: 'likes', label: this.$t('qna.order.like') },
        { value: 'comments', label: this.$t('qna.order.reply') },
      ],
      selectedOption: {},
    }
  },
  created() {
    this.setDefaultOrder();
  },
  methods: {
    ...mapActions('question', [
      'setQuestion',
      'postComment',
      'likeComments',
      'deleteComments',
      'registerQuestion',
      'cancelLikeComments',
      'changeQuestionOpenStatus'
    ]),
    sortedQuestionList(list) {
      let questionList = _.cloneDeep(list);

      switch(this.selectedOption) {
        case 'likes':
          questionList = _.orderBy(questionList, ['likes', 'regDate'], ['desc', 'desc']);
          break;
        case 'comments':
          questionList = _.orderBy(questionList, ['comments', 'regDate'], ['desc', 'desc']);
          break;
        default:
          questionList = _.orderBy(questionList, ['regDate'], ['desc']);
          break;
      }

      return questionList;
    },
    onClose() {
      this.$modal('RoomQnAModal')
    },
    getRegDateForm(date) {
      return moment(date).format('HH:mm:ss')
    },
    getCommentBtnText(question){
      let title = ''
      if(this.qnaCommentId === question.questionId){
        title = this.$t('qna.reply.hide');
      } else if(question.comments.length > 0){
        title = this.$t('qna.reply.see', { '0' : question.comments.length });
      } else {
        title = this.$t('qna.reply.write');
      }
      return title
    },
    onClickRegister(content){
      if(content.length === 0) return;
      this.$alert({
        text: this.$t('qna.register.text'),
        ok: async () => {
          await this.registerQuestion(content);
          this.onClose();
        }
      })
    },
    onClickComment(questionId, type){
      if(this.qnaCommentId !== questionId){
        this.qnaCommentId = questionId;
      } else {
        this.qnaCommentId = '';
      }
    },
    async onClickPostComment(questionId) {
      const text = this.commentText;
      if (!text?.trim().length) {
        this.$alert({
          text: this.$t('qna.reply.text'),
          onlyOk: true,
        })

        return;
      }

      try {
        await this.postComment({
          questionId,
          text,
          username: this.getUsername(),
        });

        this.commentText = '';
      } catch {
        this.$alert({
          text: this.$t('qna.reply.fail'),
          onlyOk: true,
        });
      }
    },
    deleteQnA(questionId){
      this.$alert({
        title: this.$t('qna.question.delete.title'),
        text: this.$t('qna.question.delete.text'),
        ok: async () => {
          try {
            this.setQuestion({
              questionId : questionId,
              statusType: 'del',
              value: true
              })
          } catch {
            this.$alert({
              text: this.$t('qna.question.delete.fail'),
              onlyOk: true,
            });
          }
        }
      });
    },
    async onClickDeleteComment(questionId, commentId){
      this.$alert({
        title: this.$t('qna.reply.delete.title'),
        text: this.$t('qna.reply.delete.text'),
        ok: async () => {
          try {
            await this.deleteComments({ questionId, commentId });
          } catch {
            this.$alert({
              text: this.$t('qna.reply.delete.fail'),
              onlyOk: true,
            });
          }
        }
      });
    },
    saveQuestions(){
      let text = '';
      let date = new Date();
      text = moment(date).format('yyyy-MM-dd HH:mm:ss') + this.$t('qna.saved');

      this.questionList.forEach((question, i) => {
        text += `${i}. ${question.nickname} : \n${question.content.trim()}(${this.getRegDateForm(question.regDate)}) \n`
        if(question.comments.length > 0){
          text += `\n`;
          question.comments.forEach((comment, i) => {
            text += `\t Comment${i}(${comment.username}) : ${comment.text}(${this.getRegDateForm(comment.uptDate)}) \n`
          })
        }
        text += `\n\n`
      })
      saveAs(
        new Blob(["\ufeff"+text], { type: 'text/plain;charset=utf-8;' }),
        "QNA_" + moment(date).format('yyyyMMdd_HHmmss') + ".txt"
      )
    },
    async onClickLike(question){
      const hasLike = question.likes.some(like => like.userId === this.me.userId);
      if (hasLike) {
        try {
          const likeId = question.likes.find(like => like.userId === this.me.userId).likeId;
          if (!likeId) {
            this.$alert({
              text: this.$t('qna.like.notExist'),
              onlyOk: true,
            });

            return;
          }

          await this.cancelLikeComments({
            questionId: question.questionId,
            likeId
          });
        } catch {
          this.$alert({
            text: this.$t('qna.like.cancelFail'),
            onlyOk: true,
          })
        }
      } else {
        try {
          await this.likeComments({
            questionId: question.questionId,
            username: this.getUsername(),
          });
        } catch {
          this.$alert({
            text: this.$t('qna.like.fail'),
            onlyOk: true,
          })
        }
      }
    },
    setDefaultOrder() {
      this.selectedOption = this.orderOptions[0].value;
    },
    handleSelectOption(type, option) {
      this.selectedOption = option;
    },
    onInput(e) {
      const target = e.target
      const maxLen = e.target.maxLength
      if (target.value.length > e.target.maxLength) {
        this.questionText = e.target.value = target.value.substring(0, maxLen)
        return;
      }
      this.questionText = e.target.value = target.value;
    }
  }
}
</script>

<style lang="scss" scoped>
.room-qna-modal-component {
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 60px;
  z-index: 4;
  white-space: pre-line;

  .room-qna-wrapper {
    position: relative;
    width: 500px;
    max-height: 90vh;
    padding: 30px 30px 50px 30px;
    border-radius: 12px;
    background-color: white;
    box-shadow: 0 10px 30px rgba(0,0,0,0.4);
  }

  .room-qna-header {
    h6 {
      font-size: 16px;
    }
  }

  .room-qna-content {
    margin-top: 24px;

    .qna-menu {
      display: flex;
    }

    .qna-menu-btn {
      flex: 1;
      padding: 4px 4px 10px;
      border-bottom: 2px solid #eee;
      font-size: 14px;
      color: #666;

      &.selected {
        border-color: #59f;
        font-weight: bold;
        color: black;
      }

      &.blocked{
        pointer-events: none;
        opacity: .4;
      }
    }

    .qna-order-select{
      display: flex;
      justify-content: flex-end;

      .form-select {
        width: 30%;
        border: 1px solid #e4e4e4;
        border-radius: 4px;
        padding: 0 26px 0 8px;
        background: white url('~@/assets/images/arrow_down_triangular_filled.svg') no-repeat center right 8px / 8px auto;
        font-size: 13px;
        font-weight: 500;
        color: #4b4b4b;
        line-height: 34px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        appearance: none;
        cursor: pointer;
      }
    }
    
    .qna-list-wrapper{
      margin-top: 10px;

      .qna-list{
        margin-top: 10px;
        max-height: calc(90vh - 317px);
        overflow-y: auto;
      }
    }

    .qna-items-wrap {
      position: relative;
      overflow-y: auto;
    }

    .qna-items {
      position: relative;
    }

    .qna-item {
      position: relative;
      margin-top: 10px;
      overflow: hidden;
      padding: 30px 16px 16px 16px;
      border-radius: 6px;
      background-color: #f4f4f4;

      .qna-item-wrapper {
        display: flex;
        min-height: 72px;
      }

      .qna-q {
        width: 24px;
        height: 40px;
        background: url('~@/assets/images/Q.svg') left top no-repeat;
        background-size: auto 40%;
      }

      .qna-content {
        flex: 2;
        margin-left: 6px;
        max-width: calc(100% - 30px);
        text-align: left;

        .qna-nickname {
          font-size: 14px;
          font-weight: bold;
          color: #59f;
          line-height: 1.2;
        }

        .qna-text {
          margin-top: 4px;
          font-size: 16px;
          line-height: 1.4;
          word-break: break-all;
        }

        .qna-comment-btn-wrapper{
          display: flex;
          height: 18px;
          margin-top: 8px;
          position: relative;
          font-size: 12px;
          color: #5C5C66;

          .qna-like-btn{
            display: flex;
            align-items: center;
            position: absolute;
            top: 0;
            left: 0;

            p{
              margin-left: 2px;
            }

            .qna-like-icon {
              width: 18px;
              height: 18px;
              border-radius: 4px;
              background: url('~@/assets/images/heart_empty.svg') no-repeat center / auto 70%;

              &.liked{
                background: url('~@/assets/images/heart_red.svg') no-repeat center / auto 70%;
              }
            }
          }

          .qna-comment-btn{
            margin-left: 8px;
            position: absolute;
            top: 0;
            left: 80px;
          }
        }
      }
      .qna-comment-list{
        margin-top: 10px;

        .qna-comment-item{
          display: flex;
          position: relative;

          &:hover {
            .btn-qna-comment-remove{
              opacity: 1;
            }
          }

          .qna-content{
            margin-bottom: 10px;
            .qna-nickname, .qna-text{
              font-size: 14px;
            }
          }

          .qna-comment-icon{
            width: 40px;
            height: 40px;
            background: url('~@/assets/images/arrow_comment.svg') center no-repeat;
            background-size: auto 40%;
          }

          .qna-comment-regdate{
            position: absolute;
            top: 0px;
            right: 30px;
            font-size: 12px;
            color: #c4c4c4;
          }

          .btn-qna-comment-remove {
            position: absolute;
            top: 0;
            right: 0;
            width: 20px;
            height: 20px;
            background: url('~@/assets/images/x.svg') center no-repeat;
            background-size: auto 40%;
            cursor: pointer;
            transition: 100ms ease-out;
            opacity: 0;


          }
        }
      }


      .qna-comment-input-wrapper{
        position: relative;
        padding-left: 24px;

        .qna-comment-input{
          width: 100%;
          padding: 8px 70px 8px 14px;
          resize: none;
          border: 1px solid #c8c8c8;
          border-radius: 10px;
          font-size: 14px;
          font-weight: bold;
          color: #333;
        }

        .qna-comment-register-btn{
          position: absolute;
          top: 8px;
          right: 18px;
          font-size: 14px;
          color: #c4c4c4;
          pointer-events: none;

          &.active{
            color: #59f;
            pointer-events: auto;
          }
        }
      }


      .qna-regdate{
        position: absolute;
        top: 10px;
        right: 40px;
        font-size: 12px;
        color: #c4c4c4;
      }

      .btn-qna-item-remove {
        position: absolute;
        top: 0;
        right: 0;
        width: 40px;
        height: 40px;
        background: url('~@/assets/images/trash_red.svg') center no-repeat;
        background-size: auto 40%;
        cursor: pointer;
        transition: 100ms ease-out;
        opacity: .7;

        &:hover {
          background-size: auto 44%;
          opacity: 1;
        }
      }

      &:first-child {
        margin: 0;
      }
    }

    .qna-list-empty {
      padding: 93px 0;
      text-align: center;
      font-size: 20px;
      font-weight: 300;
      color: #aaa;
    }
  }

  .qna-list-btn-wrap {
    position: absolute;
    bottom: 10px;
    right: 30px;

    .btn-qna-list-save {
      padding: 8px 10px;
      border-radius: 4px;
      border: 1px solid #999;
      font-size: 12px;
      color: #666;
      box-shadow: 0 1px 2px rgba(0,0,0,0.2);

      &:hover, &:active {
        background-color: #59f;
        border-color: #56f;
        color: white;
      }
    }
  }
  

  .qna-form-header {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;

    .qna-form-title {
      font-size: 14px;
      color: #666;
    }

    .qna-form-len-layer {
      font-size: 12px;
      color: #bdbdbd;
    }

    .qna-form-text-len {
      color: #59f;
    }
  }

  .qna-form-body {
    margin-top: 12px;

    textarea {
      width: 100%;
      height: 100px;
      padding: 10px 12px;
      resize: none;
      border-radius: 4px;
      background-color: #f4f4f4;
      border: 1px solid #ddd;
      font-size: 14px;
      color: #666;

      &::placeholder {
        letter-spacing: 0;
      }
    }
  }

  .qna-form-footer {
    margin-top: 20px;
    padding: 16px;
    border-radius: 4px;
    background-color: #ddd;
    text-align: center;
    font-size: 16px;
    color: white;
    text-shadow: 0 1px 1px rgba(0,0,0,0.1);
    cursor: default;

    &.active{
      background-color: #59f;
      cursor: pointer;

      &:hover {
        background-color: #56f;
      }
    }
  }

  .qna-close-wrap {
    position: absolute;
    top: 20px;
    right: 20px;

    .btn-qna-close {
      width: 30px;
      height: 30px;
      border-radius: 100%;
      background: url('~@/assets/images/x.svg') center / 50% no-repeat;
      opacity: .6;

      &:hover {
        background: #f05 url('~@/assets/images/x_white.svg') center / 36% no-repeat;
        opacity: 1;
      }
    }
  }

  .chk-my-qna {
    width: max-content;
    margin-top: 12px;
    cursor: pointer;

    span {
      margin-left: 6px;
    }
  }
}

[grm-device-mobile]{

  .room-qna-modal-component{
    left: 0;

    .room-qna-wrapper{
      width: 100%;
      height: 100%;
      max-height: none;
      border-radius: 0;

      .room-qna-content{
        height: calc(100% - 50px);

        .qna-list-wrapper{
          height: calc(100% - 50px) !important;
        }

        .qna-list{
          max-height: none;
          height: calc(100% - 46px);
        }
      }
    }
    .qna-order-select{
      .form-select{
        width: 40%;
      }
    }
  }
}

.slide-down {
  transition: all 0.5s;
}
.slide-down-enter-active {
  transition: all 0.5s ease;
}
.slide-down-leave-active {
  transition: all 0.25s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-down-leave-active,
.slide-down-enter{
  opacity: 0;
  transform: translateY(-5%);
}
</style>